// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__jtAxl","right":"Button_right__1Fvm6"};